/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type ReportsFindSimilarReportsParams = {
  /**
   * Filter by species
   */
  specie: string;
  /**
   * Filter by etiological agent code
   */
  etiologicalAgentCode?: string;
  /**
   * Latitude
   */
  latitude: number;
  /**
   * Longitude
   */
  longitude: number;
};
